import { readonly, ref } from "vue";
import { apiRequest } from "@/services";

const configured = ref(false);
const capabilities = ref({ legacyPrompts: false, distributionCopy: false, scriptDraft: false, performanceInsights: false, assetMetadata: false });
const compatibleProvider = ref({ configured: false, provider: null, model: null, endpointHost: null, configurationError: null });
const loaded = ref(false);
let pendingRequest = null;

export async function loadAiAvailability(force = false) {
    if (loaded.value && !force) return configured.value;
    if (pendingRequest && !force) return pendingRequest;

    pendingRequest = apiRequest("get", "/api/v1/ai/status")
        .then((response) => {
            configured.value = response?.data?.configured === true;
            capabilities.value = {
                legacyPrompts: response?.data?.capabilities?.legacyPrompts === true,
                distributionCopy: response?.data?.capabilities?.distributionCopy === true,
                scriptDraft: response?.data?.capabilities?.scriptDraft === true,
                performanceInsights: response?.data?.capabilities?.performanceInsights === true,
                assetMetadata: response?.data?.capabilities?.assetMetadata === true,
            };
            compatibleProvider.value = response?.data?.compatibleProvider || compatibleProvider.value;
            return configured.value;
        })
        .catch(() => {
            configured.value = false;
            capabilities.value = { legacyPrompts: false, distributionCopy: false, scriptDraft: false, performanceInsights: false, assetMetadata: false };
            return false;
        })
        .finally(() => {
            loaded.value = true;
            pendingRequest = null;
        });

    return pendingRequest;
}

export function isAiConfigured() {
    return configured.value;
}

export function useAiAvailability() {
    return {
        aiConfigured: readonly(configured),
        aiCapabilities: readonly(capabilities),
        compatibleAiProvider: readonly(compatibleProvider),
        aiAvailabilityLoaded: readonly(loaded),
        loadAiAvailability,
    };
}
